import { getPostalCode } from 'services/apis/postal-code-api';
import { SEARCH_POSTAL_CODE } from 'constants/postal-code';

export const getPostalCodeAction = (cp) => ({
  type: SEARCH_POSTAL_CODE,
  payload: getPostalCode(cp),
});
